import React from "react";
import { Header } from "../../header";

export default () => {
  return (
    <div className="e-settings-layout">
      <Header title="Break even" showMenu={false}></Header>
      <div className="e-settings-content">
        <p>
          With this strategy builder app, you can find the breakeven value for
          both the call and put options in your strategy
        </p>
        <p>
          Break even point is the price at which your positions will neither be
          in profit nor loss i.e profit or loss at $0.
        </p>
        <p>
          If your strategy is *nett long and break even value is close to the
          stock price, then your chance of profiting is very high.
        </p>

        <p>
          "nett long" refers to strategies that have bought calls or puts more
          than selling calls or puts. i.e Value of buy positions greater than
          sell positions
        </p>
        <p>
          If your strategy is *nett short, then your chance of profit is high if
          the break even value is very far from the stock price.
        </p>
        <p>
          "nett short" refers to strategies that have sold calls or puts more
          than buying calls or puts. i.e Value of sell positions greater than
          buy positions
        </p>
      </div>
    </div>
  );
};
